import { PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { loadScript, useGoogleOAuthURL, useLoader, useUpdateGoogleMyBusinessCreds } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
import React, { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import messages from "../messages.i18n";
import { PUBLISH_TO_GMB_STEPS } from "./constant";
export const GoogleMyBusinessAuth = ({ setPublishToGMBStep }) => {
    const intl = useIntl();
    const loadedGoogleGISScript = useRef(false);
    const oauth2Client = useRef(null);
    const { user, reloadCurrentUser } = useAuthContext();
    const { setLoader } = useLoader();
    const [getGoogleOAuthURL, googleOAuthURL, googleOAuthURLInProgress, googleOAuthURLError] = useGoogleOAuthURL();
    const [updateGoogleMyBusinessCreds, googleMyBusinessCredsUpdated, updateGoogleMyBusinessCredsInProgress, updateGoogleMyBusinessCredsError,] = useUpdateGoogleMyBusinessCreds();
    useEffect(() => {
        setLoader(googleOAuthURLInProgress || updateGoogleMyBusinessCredsInProgress);
        return () => setLoader(false);
    }, [googleOAuthURLInProgress, updateGoogleMyBusinessCredsInProgress]);
    const initiateGISClient = (params) => {
        const { scope, client_id } = Object.fromEntries(params);
        //@ts-ignore
        oauth2Client.current = google.accounts.oauth2.initCodeClient({
            scope,
            client_id,
            ux_mode: "popup",
            callback: (tokenResponse) => {
                updateGoogleMyBusinessCreds({ code: tokenResponse.code });
            },
        });
    };
    useEffect(() => {
        if (!user.googleCredentials) {
            getGoogleOAuthURL();
            return setPublishToGMBStep(PUBLISH_TO_GMB_STEPS.GMB_AUTH);
        }
        return setPublishToGMBStep(PUBLISH_TO_GMB_STEPS.PROPERTY_SELECTION);
    }, [user]);
    useEffect(() => {
        if (!googleOAuthURL)
            return;
        const gmbAuthUrl = new URL(googleOAuthURL);
        if (typeof window !== "undefined" &&
            !loadedGoogleGISScript.current &&
            !document.querySelector("#google-gsi-client")) {
            loadScript("https://accounts.google.com/gsi/client", document.querySelector("head"), "google-gsi-client", () => initiateGISClient(gmbAuthUrl.searchParams));
            loadedGoogleGISScript.current = true;
        }
        else {
            initiateGISClient(gmbAuthUrl.searchParams);
        }
    }, [googleOAuthURL]);
    useEffect(() => {
        if (googleOAuthURLError || updateGoogleMyBusinessCredsError) {
            setPublishToGMBStep(PUBLISH_TO_GMB_STEPS.GMB_ERROR);
        }
    }, [googleOAuthURLError, updateGoogleMyBusinessCredsError]);
    useEffect(() => {
        if (googleMyBusinessCredsUpdated) {
            setPublishToGMBStep(PUBLISH_TO_GMB_STEPS.PROPERTY_SELECTION);
            reloadCurrentUser();
        }
    }, [googleMyBusinessCredsUpdated]);
    const moveToGoogleAuthFlow = () => {
        oauth2Client.current.requestCode();
    };
    return (React.createElement(PeekStack, { height: "100%", justifyContent: "space-between", spacing: 2 },
        React.createElement(PeekTypography, null, intl.formatMessage(messages.spacePublishToGMBAuthDescription)),
        React.createElement(PeekStack, { alignItems: "center" },
            React.createElement("img", { src: "/images/gmb_auth.png", width: 282, height: 443, alt: "GMB auth image" })),
        React.createElement(PeekButton, { fullWidth: true, size: "large", variant: "contained", color: "primary", onClick: moveToGoogleAuthFlow }, intl.formatMessage(messages.spacePublishToGMBNextButton))));
};
export default GoogleMyBusinessAuth;
